import { Link } from 'react-router-dom';

export default function AboutSnapshot() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative rounded-3xl overflow-hidden shadow-2xl h-[600px]">
            <img 
              src="https://public.readdy.ai/ai/img_res/2436cfe0317525d1a8f1ded590b37629.jpg"
              alt="Our Team"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-[#FF6B6B] text-white text-sm font-semibold rounded-full mb-6">
              Our Mission
            </div>
            
            <h2 className="text-5xl font-bold text-[#1A2332] mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Empowering Homeowners to Build Wealth Through Hosting
            </h2>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              We believe every homeowner should have the opportunity to generate income from their property. With over 15 years of combined experience in real estate, hospitality, and property management, our team has helped hundreds of homeowners successfully launch and manage profitable Airbnb properties.
            </p>

            <p className="text-lg text-gray-600 mb-10 leading-relaxed">
              From navigating complex building codes to optimizing revenue algorithms, we provide the expertise and support needed to transform your property into a thriving short-term rental business.
            </p>

            <div className="grid grid-cols-2 gap-8 mb-10">
              <div>
                <div className="text-5xl font-bold text-[#FF6B6B] mb-2">500+</div>
                <p className="text-lg text-[#1A2332] font-semibold">Properties Transformed</p>
              </div>
              <div>
                <div className="text-5xl font-bold text-[#FF6B6B] mb-2">$12M+</div>
                <p className="text-lg text-[#1A2332] font-semibold">Revenue Generated for Hosts</p>
              </div>
            </div>

            <Link 
              to="/about"
              className="inline-block border-2 border-[#1A2332] text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-[#1A2332] hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              Meet the Team
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
